import styled from 'styled-components';
import { fontTitle, fontBody } from 'Styles/fonts';

import ButtonOriginal from '../Button/Button';

export const Title = styled.div`
  ${fontTitle(32)};
  margin-bottom: 4px;
`;

export const Subtitle = styled.div`
  ${fontBody(16)};
`;

export const ImageContainer = styled.div`
  width: 250px;
  margin: 16px auto;
`;

export const Button = styled(ButtonOriginal)`
  margin-top: 16px;
`;

export default {};
